import { useStore } from '@/state/store';
import { GENERIC_TAX_DEFAULTS } from '@/types';

/** Save / reset the reusable tax profile (§6.20, §10.2). Only affects NEW scenarios. */
export function TaxProfileControls() {
  const taxProfile = useStore((s) => s.taxProfile);
  const save = useStore((s) => s.saveTaxProfileFromCurrent);
  const setInputs = useStore((s) => s.setInputs);

  return (
    <div className="flex flex-col gap-2">
      <div className="rounded bg-caution-bg px-2 py-1 text-[11px] text-caution">
        These tax values are generic estimates inherited from defaults. Tune them to your situation —
        they are not advice.
      </div>
      <div className="flex flex-wrap gap-2">
        <button type="button" className="rounded border border-slate-300 px-2 py-1 text-xs hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800" onClick={() => void save()}>
          Save as my tax profile
        </button>
        {taxProfile && (
          <button type="button" className="rounded border border-slate-300 px-2 py-1 text-xs hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800" onClick={() => setInputs({ tax: taxProfile })}>
            Reset to my tax profile
          </button>
        )}
        <button type="button" className="rounded border border-slate-300 px-2 py-1 text-xs hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800" onClick={() => setInputs({ tax: GENERIC_TAX_DEFAULTS })}>
          Reset to generic defaults
        </button>
      </div>
    </div>
  );
}
